export default {
    lt: '<',
    lte: '<=',
    gt: '>',
    gte: '>=',
    notEquals: 'not',
    is: 'equals',
    isNot: 'not',
    before: '<',
    after: '>'
};
